<template>
    <DnAccordion
        ref="accordion"
        :items="[items]"
        :scroll-into-view="false"
        :scroll-smooth="true"
        class="base-accordion base-accordion--block"
        :open-indexes="[]"
    >
        <template #title>
            <div>
                <h4>
                    {{ title }}
                </h4>
                <p>
                    {{ description }}
                </p>
                <label>{{ label }}</label>
            </div>
        </template>


        <template #default>
            <FlexibleSections
                :sections="Array.isArray(items) ? items : []"
                :full-width="true"
            />
        </template>

        <template #icon>
            <BaseIcon
                style="margin-top: auto;"
                icon="chevron-down"
            />
        </template>
    </DnAccordion>
</template>

<script setup lang="ts">
import DnAccordion from '@digitalnatives/accordion';
import BaseIcon from '~/components/BaseIcon/BaseIcon.vue';

type Props = {
    title: string,
    description: string,
    label: string,
    items: Array<any>,
};

defineProps<Props>();
</script>
<style lang="less">
.base-accordion--block {
    background: var(--hero-bg-color);
    margin-top: var(--spacing-sm);
    padding: var(--spacing-lg) 1.125rem;
    border: 1px solid #FFE4B1; // var(--color-primary);
    border-radius: 6px;

    p {
        font-weight: 400;
    }

    .dn-accordion__button {
        padding-block: 0;

        p {
            color: var(--color-darkest);
        }

        &:hover p {
            color: var(--color-darkest);
        }
    }

    .dn-accordion__item {
        border: none;

    }

    .dn-accordion__icon {
        margin-top: auto;
        margin-bottom: 1.44rem;
    }

    @media @q-md-min {
        padding: 1.62rem var(--spacing-lg);
    }
}
</style>
